import { NEIGHBORHOODS } from './seedData';
import { BOSTON_AREAS, MILWAUKEE_AREAS, NYC_BOROUGHS, PORTLAND_AREAS } from './cityAreas';

export const DEFAULT_RADIUS_MILES = 50;
export const MIN_AREAS_FOR_FILTER = 4;
export const MIN_BARS_FOR_MAP_AREA_FILTER = 25;
export const HOMETOWN_STORAGE_KEY = 'tilted_hometown_metro';
export const METRO_OVERRIDE_STORAGE_KEY = 'tilted_metro_override';
export const GPS_OPT_IN_KEY = 'tilted_gps_opt_in';

export const METROS = [
  {
    id: 'chicago',
    slug: 'chicago',
    name: 'Chicago',
    state: 'IL',
    center: { lat: 41.8781, lng: -87.6298 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: true,
    areas: NEIGHBORHOODS,
  },
  {
    id: 'milwaukee',
    slug: 'milwaukee',
    name: 'Milwaukee',
    state: 'WI',
    center: { lat: 43.0389, lng: -87.9065 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: true,
    areas: MILWAUKEE_AREAS,
  },
  {
    id: 'pittsburgh',
    slug: 'pittsburgh',
    name: 'Pittsburgh',
    state: 'PA',
    center: { lat: 40.4406, lng: -79.9959 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'South Side',
      'Bloomfield',
      'Polish Hill',
      'Strip District',
      'North Side',
      'Shadyside',
      'East Liberty',
      'Squirrel Hill',
      'Oakland',
      'Downtown',
      'Millvale',
      'Allentown',
      'Mount Washington',
    ],
  },
  {
    id: 'philadelphia',
    slug: 'philadelphia',
    name: 'Philadelphia',
    state: 'PA',
    center: { lat: 39.9526, lng: -75.1652 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'Center City',
      'Fishtown',
      'Northern Liberties',
      'South Philly',
      'Passyunk',
      'West Philly',
      'University City',
      'Kensington',
      'Queen Village',
      'Old City',
      'Manayunk',
      'East Falls',
      'Port Richmond',
      'Roxborough',
    ],
  },
  {
    id: 'boston',
    slug: 'boston',
    name: 'Boston',
    state: 'MA',
    center: { lat: 42.3601, lng: -71.0589 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: true,
    areas: BOSTON_AREAS,
  },
  {
    id: 'nyc',
    slug: 'nyc',
    name: 'New York City',
    shortName: 'NYC',
    state: 'NY',
    center: { lat: 40.7128, lng: -74.006 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    groupLabel: 'Borough',
    enabled: true,
    groups: NYC_BOROUGHS,
    areas: NYC_BOROUGHS.flatMap((group) => group.areas),
  },
  {
    id: 'seattle',
    slug: 'seattle',
    name: 'Seattle',
    state: 'WA',
    center: { lat: 47.6062, lng: -122.3321 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'Capitol Hill',
      'Ballard',
      'Fremont',
      'Georgetown',
      'Pioneer Square',
      'Belltown',
      'University District',
      'Columbia City',
    ],
  },
  {
    id: 'sf',
    slug: 'sf',
    name: 'San Francisco',
    state: 'CA',
    center: { lat: 37.7749, lng: -122.4194 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'Mission',
      'North Beach',
      'Tenderloin',
      'Castro',
      'SOMA',
      'Lower Haight',
      'Richmond',
      'Excelsior',
    ],
  },
  {
    id: 'la',
    slug: 'la',
    name: 'Los Angeles',
    state: 'CA',
    center: { lat: 34.0522, lng: -118.2437 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'Downtown',
      'Silver Lake',
      'Los Feliz',
      'Highland Park',
      'Echo Park',
      'East Hollywood',
      'Santa Monica',
      'Long Beach',
    ],
  },
  {
    id: 'austin',
    slug: 'austin',
    name: 'Austin',
    state: 'TX',
    center: { lat: 30.2672, lng: -97.7431 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'East Austin',
      'Downtown',
      'South Congress',
      'Rainey Street',
      'Dirty Sixth',
      'North Loop',
      'Hyde Park',
      'South Lamar',
    ],
  },
  {
    id: 'detroit',
    slug: 'detroit',
    name: 'Detroit',
    state: 'MI',
    center: { lat: 42.3314, lng: -83.0458 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: false,
    areas: [
      'Corktown',
      'Midtown',
      'Downtown',
      'Hamtramck',
      'Ferndale',
      'Royal Oak',
      'Mexicantown',
      'Eastern Market',
    ],
  },
  {
    id: 'portland',
    slug: 'portland',
    name: 'Portland',
    state: 'OR',
    center: { lat: 45.5152, lng: -122.6784 },
    radiusMiles: DEFAULT_RADIUS_MILES,
    usesNeighborhoods: true,
    areaLabel: 'Neighborhood',
    enabled: true,
    areas: PORTLAND_AREAS,
  },
];

export function getEnabledMetros() {
  return METROS.filter((metro) => metro.enabled);
}

export function getMetroById(id) {
  if (!id) return null;
  return METROS.find((metro) => metro.id === id || metro.slug === id) || null;
}

export function getMetroAreas(metro) {
  if (metro?.groups?.length) {
    return metro.groups.flatMap((group) => group.areas || []);
  }
  return metro?.areas || [];
}

export function getMetroFilterAreas(metro) {
  if (metro?.groups?.length) {
    return metro.groups.map((group) => group.name);
  }
  return getMetroAreas(metro);
}

export function getAreasForGroup(metro, groupName) {
  if (!metro?.groups?.length || !groupName) return [];
  return metro.groups.find((group) => group.name === groupName)?.areas || [];
}

export function shouldShowAreaFilter(metro) {
  if (!metro) return false;
  if (!metro.usesNeighborhoods) return false;
  return getMetroFilterAreas(metro).length >= MIN_AREAS_FOR_FILTER;
}

export function getAreaLabel(metro) {
  if (metro?.groups?.length) return metro.groupLabel || 'Borough';
  return metro?.areaLabel || 'Area';
}
